export enum AppDataEventObject {
  PAGE = 'page',
  ANNOUNCEMENT = 'announcement',
  POLICY_VIOLATION_WARNING = 'policy_violation_warning',
  USER_SURVEY = 'user_survey',
  SEND_TO_SUPPORT = 'send_to_support',
  CONTACT_SUPPORT_DIALOG = 'contact_support_dialog',
}
